Pegasus.TabView = Em.View.extend({
  tagName: 'li',
  classNames: ['tab'],
  classNameBindings: ['isActive:active'],
  mode: null,
  isActive: function(){
    return this.get('parentView.activeMode') === this.get('mode');
  }.property('parentView.activeMode'),
  moveUnderline: function(){
    Em.run.scheduleOnce('afterRender', this, function(){
      if ( this.$() && this.get('isActive') ) {
        this.$().closest('div').find('.tab-underline').css({
          left: this.$().position().left, /*frame padding*/
          width: this.$().width()
        });
      }
    });
  }.observes('isActive'),
  didInsertElement: function(){
    this._super();
    this.moveUnderline();
  },
  click: function(){
    this.get('parentView').selectView( this.get('mode') );
  }
});
